import { Injectable } from "@angular/core";
import { Funding } from "@models/funding.model";
import BaseService from "./base.service";

/**
 * A variant of the BaseService where the Funding's information is stored.
 *
 * @class FundingService
 * @augments {BaseService<Funding>}
 */
@Injectable({
  providedIn: "root",
})
export class FundingService extends BaseService<Funding> {}
